
import { Injectable, Injector } from '@angular/core';
import { HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { ScrServiceManager } from './servicemanager.service';
import { NGXLogger } from 'ngx-logger';
import { tap, finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ScrBusyInterceptor implements HttpInterceptor {

  private ssm: ScrServiceManager;
  private outstanding = 0;

  constructor(inj: Injector, private logger: NGXLogger) {
    this.ssm = inj.get(ScrServiceManager);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    this.logger.trace('intercept no busy is ' + this.ssm.nobusy);
    if (this.ssm.nobusy) {
      this.ssm.nobusy = false;
      return next.handle(req);
    }
    return next.handle(req)
      .pipe(
        tap(event => {
          if (event.type === HttpEventType.Sent) {
            this.logger.trace("start busy " + this.outstanding);
            this.outstanding = this.outstanding + 1;
            this.ssm.setOutstanding(this.outstanding);
          }
          else {
            this.logger.trace("not processing response type of " + event.type);
          }
        }),
        finalize(()=> {
          this.logger.trace("end busy " + this.outstanding);
          this.outstanding = this.outstanding - 1;
          // just be sure.
          if (this.outstanding < 0) {
            this.outstanding = 0;
          }
          this.ssm.setOutstanding(this.outstanding);
        }));
  }

  public increment() {
    this.outstanding = this.outstanding + 1;
    this.logger.trace('increment: outstanding now ' + this.outstanding);  
    this.ssm.setOutstanding(this.outstanding);
  }

  public decrement() {
    this.outstanding = this.outstanding - 1;
    // just be sure.
    if (this.outstanding < 0) {
      this.outstanding = 0;
    }
    this.logger.debug('decrement: outstanding now ' + this.outstanding);
    this.ssm.setOutstanding(this.outstanding);
  }
}


